var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256S397 0 256 0zm107.97 365.27h-92.636v35.663c0 8.432-6.901 15.338-15.336 15.338-8.429 0-15.33-6.906-15.33-15.338V365.27H148.03c-41.384 0-75.03-33.647-75.03-75.031 0-38.765 29.527-70.73 67.275-74.626 3.928-60.398 54.297-108.316 115.672-108.316 61.373 0 111.732 47.912 115.67 108.304C409.416 219.442 439 251.44 439 290.24c0 41.383-33.647 75.03-75.03 75.03zm-92.636-99.543v99.543h-30.666v-99.543l-32.888 32.888c-5.988 5.988-15.699 5.989-21.686-.001-5.985-5.988-5.987-15.699.001-21.687l59.064-59.062c5.984-5.984 15.7-5.984 21.684 0l59.063 59.062c5.987 5.987 5.988 15.701-.001 21.688a15.31 15.31 0 0 1-10.841 4.493 15.307 15.307 0 0 1-10.842-4.493z",
    clipRule: "evenodd",
    fill: "#24396b",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.e17f8efb0e8d248d8330f95387f0a4a4.svg";
export { ForwardRef as ReactComponent };